 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED734 from '@/components/Untitled-7-34'
 import UNTITLED735 from '@/components/Untitled-7-35'
 import UNTITLED736 from '@/components/Untitled-7-36'
 import UNTITLED737 from '@/components/Untitled-7-37'
 import UNTITLED738 from '@/components/Untitled-7-38'
 import UNTITLED739 from '@/components/Untitled-7-39'
 import UNTITLED740 from '@/components/Untitled-7-40'
 import UNTITLED741 from '@/components/Untitled-7-41'
 import UNTITLED742 from '@/components/Untitled-7-42'
 import UNTITLED743 from '@/components/Untitled-7-43'
 import UNTITLED744 from '@/components/Untitled-7-44'
 import UNTITLED745 from '@/components/Untitled-7-45'
 import UNTITLED746 from '@/components/Untitled-7-46'
 import UNTITLED747 from '@/components/Untitled-7-47'
 import UNTITLED748 from '@/components/Untitled-7-48'
 import UNTITLED749 from '@/components/Untitled-7-49'
 import UNTITLED750 from '@/components/Untitled-7-50'
 import UNTITLED751 from '@/components/Untitled-7-51'
 import UNTITLED752 from '@/components/Untitled-7-52'
 import UNTITLED753 from '@/components/Untitled-7-53'
 import UNTITLED754 from '@/components/Untitled-7-54'
 import UNTITLED755 from '@/components/Untitled-7-55'
 import UNTITLED756 from '@/components/Untitled-7-56'
 import UNTITLED757 from '@/components/Untitled-7-57'
 import UNTITLED758 from '@/components/Untitled-7-58'
 import UNTITLED759 from '@/components/Untitled-7-59'
 import UNTITLED760 from '@/components/Untitled-7-60'
 import UNTITLED761 from '@/components/Untitled-7-61'
 import UNTITLED762 from '@/components/Untitled-7-62'
 import UNTITLED763 from '@/components/Untitled-7-63'
 import UNTITLED764 from '@/components/Untitled-7-64'
 import UNTITLED765 from '@/components/Untitled-7-65'
 import UNTITLED766 from '@/components/Untitled-7-66'
 import UNTITLED767 from '@/components/Untitled-7-67'
 import UNTITLED768 from '@/components/Untitled-7-68'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/portalist",
 			"name" : "portalist",
 			"component" : PORTALIST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled-7-34",
 			"name" : "Untitled-7-34",
 			"component" : UNTITLED734
 		},
 		{
 			"path" : "/Untitled-7-35",
 			"name" : "Untitled-7-35",
 			"component" : UNTITLED735
 		},
 		{
 			"path" : "/Untitled-7-36",
 			"name" : "Untitled-7-36",
 			"component" : UNTITLED736
 		},
 		{
 			"path" : "/Untitled-7-37",
 			"name" : "Untitled-7-37",
 			"component" : UNTITLED737
 		},
 		{
 			"path" : "/Untitled-7-38",
 			"name" : "Untitled-7-38",
 			"component" : UNTITLED738
 		},
 		{
 			"path" : "/Untitled-7-39",
 			"name" : "Untitled-7-39",
 			"component" : UNTITLED739
 		},
 		{
 			"path" : "/Untitled-7-40",
 			"name" : "Untitled-7-40",
 			"component" : UNTITLED740
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js